import { Pipe, PipeTransform } from '@angular/core';
import { CMS_END_POINTS } from '../const/api';
import { ConfigService } from '../services/config.service';

@Pipe({
  name: 'videoSource'
})
export class VideoSourcePipe implements PipeTransform {

  constructor(private configService: ConfigService){}

  transform(videoFile: string): string {
    return videoFile ? this.configService.baseURL + CMS_END_POINTS.GET_VIDEO_BY_FILE + "?id=" + videoFile : 'https://www.w3schools.com/html/mov_bbb.mp4';
  }

}
